import { Component, OnInit, OnDestroy } from '@angular/core';
import { interval, Observable, Subscription } from 'rxjs';
import { ClientContextService, ContextChange } from '@sdbn/appclient';
import { TMCClientParameters } from 'src/tmc-common/tmc-client-parameters';
import { TranslationService } from '@sdbn/common';
import { StationStatus } from '../model/station-status';
import { environment } from 'src/environments/environment';
import { AbstractWidgetComponent } from '@sdbn/appclient';
import { ConfigurationService } from '@sdbn/appclient';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '@sdbn/appclient';

@Component({
  selector: 'app-station-status',
  templateUrl: './station-status.component.html',
  styleUrls: ['./station-status.component.scss']
})
export class StationStatusComponent extends AbstractWidgetComponent implements OnInit, OnDestroy {

  serverRoot = environment.tmcBaseUrl;
  stationIdentifier: string;
  stationId: number;

  gateLabel = null;
  stationStatus: StationStatus;

  refreshEnabled = true;
  refreshInterval = 30000;
  refreshTimer: Subscription;

  darkMode: boolean;

  visibleAttributes = new Array<string>();

  tenant?: string;

  cameraUrl?: string;

  constructor(
    private clientContextService: ClientContextService,
    private route: ActivatedRoute,
    private http: HttpService,
    public translationService: TranslationService,
    private configurationService: ConfigurationService) {

    super();
    this.tenant = this.clientContextService.getCurrentContext().unit?.key;

    configurationService.paramsChanged$.subscribe(params => {
      if (params != null && params.size > 0) { // Wir warten bis das Laden von Properties abgeschlossen wurde
        this.visibleAttributes.splice(0, this.visibleAttributes.length);
        const columnProperty = this.configurationService.getClientParamValue(TMCClientParameters.P_DISPLAY_STATION_STATUS_DETAILS, null);

        if (columnProperty != null && String(columnProperty).length > 0) {
          const columProperties = String(columnProperty).split('|');
          for (const p of columProperties) {
            this.visibleAttributes.push(p);
          }
        } else {
          this.visibleAttributes.push('carrier');
          this.visibleAttributes.push('cargo');
          this.visibleAttributes.push('string1');
          this.visibleAttributes.push('order-reference');
          this.visibleAttributes.push('processing-time');
          this.visibleAttributes.push('planningHint');
          this.visibleAttributes.push('trailerOrTruckIdentifier');
        }
      }

    });
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
    this.refreshEnabled = this.widgetReference.data?.refreshEnabled == null ? true : this.widgetReference.refreshEnabled;
    if (this.widgetReference.refreshInterval != null && this.widgetReference.refreshInterval > 0) {
      this.refreshInterval = this.widgetReference.refreshInterval * 1000;
    } else {
      this.refreshInterval = 30 * 1000;
    }

    const params = this.route.snapshot.queryParamMap;

    this.cameraUrl = params.get('cameraUrl');
    const stationIdentifier = params.get('stationIdentifier');

    if (stationIdentifier != null) {
      console.log('Using stationIdentifier [' + stationIdentifier + '] from current queryParams');
      this.stationIdentifier = stationIdentifier;
    } else if (this.widgetReference.data?.stationId != null) {
      console.log('Using stationId [' + this.widgetReference.data?.stationId + '] from current widget configuration');
      this.stationId = this.widgetReference.data?.stationId;
    }


    if (params.get('cameraUrl') != null) {
      this.cameraUrl = params.get('cameraUrl');
    } else if(this.widgetReference.data?.cameraUrl != null) {
      this.cameraUrl = this.widgetReference.data?.cameraUrl;
    }

    this.darkMode = this.widgetReference.data?.darkMode;
    this.loadStationStatus();
    this.registerRefreshTimer();
  }

  ngOnInit() {
    if(this.translationService.translationExists('supervision-station-status.gate-label', this.translationService.language)) {
      this.gateLabel = this.translationService.translate('supervision-station-status.gate-label');
    } else {
      this.gateLabel = "";
    }
  }

  ngOnDestroy() {

    super.ngOnDestroy();

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }
  }

  registerRefreshTimer() {

    if (this.refreshTimer) {
      this.refreshTimer.unsubscribe();
    }

    if (environment.autoreload && this.refreshEnabled) {
      this.refreshTimer = interval(this.refreshInterval).subscribe(n => {
        this.loadStationStatus();
        this.refreshCameraUrl();
      });
    }
  }

  private refreshCameraUrl() {
    if (this.cameraUrl != null) {
      let url = this.cameraUrl;
      if (url.indexOf('?') > -1) {
        url = url.substring(0, this.cameraUrl.indexOf('?'));
      }
      this.cameraUrl = url + '?t=' + (+Date.now())%100;
    }
  }

  private loadStationStatus() {
    if (this.stationIdentifier == null && this.stationId == null) {
      return;
    }

    this.getStationStatus({ stationIdentifier: this.stationIdentifier, stationId: this.stationId }).subscribe(
      result => {
        this.stationStatus = result;
      }, error => {
        console.log('Error wihle Loading StationStatus with identifier [' + this.stationIdentifier + ']!', error);
      }
    );
  }

  public getStationStatus(query: any): Observable<StationStatus> {
    const url = `${environment.displaysEndpoint}/stationstatus`;
    return this.http.postWithContext<StationStatus>(url, query);
  }

  getLabelByAttribute(attribute: string): string {
    if (attribute === 'cargo') {
      return 'Ldg';
    }

    if (attribute === 'carrier') {
      return 'Spd';
    }

    if (attribute === 'processing-time') {
      return 'DLZ';
    }

    if (attribute === 'string1') {
    }

    if (attribute === 'order-reference') {
      return 'Ref';
    }

    if (attribute === 'trailerOrTruckIdentifier') {
      return 'Knz';
    }

    if (attribute === 'planningHint') {
      return 'Anm';
    }

    return '';
  }

  getValueByAttribute(attribute: string): string {
    if (attribute === 'cargo') {
      return this.stationStatus.cargo;
    }

    if (attribute === 'carrier') {
      return this.stationStatus.carrier;
    }

    if (attribute === 'processing-time') {
      return this.stationStatus.processingTime;
    }

    if (attribute === 'string1') {
      return this.stationStatus.string1;
    }

    if (attribute === 'order-reference') {
      return this.stationStatus.orderReference;
    }

    if (attribute === 'trailerOrTruckIdentifier') {
      return this.stationStatus.trailerOrTruckIdentifier;
    }

    if (attribute === 'planningHint') {
      return this.stationStatus.planningHint == '' || this.stationStatus.planningHint == null ? 'ohne Anm.' : this.stationStatus.planningHint;
    }

    return '';
  }

  hasAttributeValue(attribute: string): boolean {
    if (attribute === 'cargo') {
      return this.stationStatus.cargo != null && this.stationStatus.cargo != '';
    }

    if (attribute === 'carrier') {
      return this.stationStatus.carrier != null && this.stationStatus.carrier != '';
    }

    if (attribute === 'processing-time') {
      return this.stationStatus.processingTime != null && this.stationStatus.processingTime != '';
    }

    if (attribute === 'string1') {
      return this.stationStatus.string1 != null && this.stationStatus.string1 != '';
    }

    if (attribute === 'order-reference') {
      return this.stationStatus.orderReference != null && this.stationStatus.orderReference != '';
    }

    if (attribute === 'trailerOrTruckIdentifier') {
      return this.stationStatus.trailerOrTruckIdentifier != null && this.stationStatus.trailerOrTruckIdentifier != '';
    }

    if (attribute === 'planningHint') {
      return true;
    }

    return false;
  }

  calculteFontSize() {
    if (this.visibleAttributes.length <= 4) {
      return '6vw';
    }
    return '3vw';
  }

  calculteLineHeight() {
    if (this.visibleAttributes.length <= 4) {
      return '6vw';
    }
    return '3vw';
  }

  getClassForAttribute(attribute: string) {
    if (attribute === 'processing-time') {
      return this.stationStatus.processingTimeStyle;
    }
  }

  hasStationDisablement(): boolean {
    return !this.stationStatus.locked && this.stationStatus.disablementNote !== '' && this.stationStatus.disablementNote !== null;
  }

  isLocked(): boolean {
    return this.stationStatus.locked;
  }
}
